// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {connect} from 'react-redux';
import {type ActionCreatorsMapObject, bindActionCreators, type Dispatch} from 'redux';

import {type ActionFunc, type GenericAction} from 'mattermost-redux/types/actions';
import {type DoAppSubmit, type DoAppFetchForm, type DoAppLookup, type PostEphemeralCallResponseForContext} from 'types/apps';

import {doAppSubmit, doAppFetchForm, doAppLookup, postEphemeralCallResponseForContext} from 'actions/apps';

import {type GlobalState} from 'types/store';
import {getDialogChannelId} from 'mattermost-redux/selectors/entities/integrations';
import {getCurrentChannelId} from 'mattermost-redux/selectors/entities/channels';

import AppsFormContainer from './apps_form_container';

type Actions = {
    doAppSubmit: DoAppSubmit<any>;
    doAppFetchForm: DoAppFetchForm<any>;
    doAppLookup: DoAppLookup<any>;
    postEphemeralCallResponseForContext: PostEphemeralCallResponseForContext;
};

function mapStateToProps(state: GlobalState) {
    const channelId = getDialogChannelId(state);
    const currentChannelId = getCurrentChannelId(state);

    return {
        channelId: channelId || currentChannelId,
    };
}

function mapDispatchToProps(dispatch: Dispatch<GenericAction>) {
    return {
        actions: bindActionCreators<ActionCreatorsMapObject<ActionFunc>, Actions>({
            doAppSubmit,
            doAppFetchForm,
            doAppLookup,
            postEphemeralCallResponseForContext,
        }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppsFormContainer);
